export default __webpack_public_path__ + "static/media/project.00da84c6.WebP";